/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

import {
  WithDropdown
} from '../'

export const ToolbarItem = ({ label, value, children, dropdownContent, dropdownOpen, onDropdownClick, className }) => {
  let content = (
    <div className='slds-grid'>
      <div className='slds-wrap slds-col'>
        {value}
      </div>
      {children &&
        <div className='slds-col_bump-left'>
          <div className='action-toolbar__item-action'>
            {children}
          </div>
        </div>
      }
    </div>
  )

  return (
    <div className={`action-toolbar__item slds-col slds-p-top_medium slds-p-bottom_medium slds-p-left_small slds-p-right_small ${className}`}>
      <div className='action-toolbar__item-label'>
        {label}
      </div>
      {dropdownContent
        ? <div className={onDropdownClick ? 'clickable' : ''} onClick={onDropdownClick ? (e) => onDropdownClick(e) : undefined}>
            <WithDropdown
              dropdownContent={dropdownContent}
              open={dropdownOpen}
              minWidth={180}
              minHeight={50}
              className='slds-m-right_x-small slds-size_1-of-1'>
              {content}
            </WithDropdown>
          </div>
        : content
      }
    </div>
  )
}

ToolbarItem.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
  action: PropTypes.any,
  dropdown: PropTypes.bool,
  className: PropTypes.string
}

ToolbarItem.defaultProps = {
  dropdown: false,
  className: ''
}



// WEBPACK FOOTER //
// ./src/components/toolbar-item/index.js